import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('https://mevteck.com/invoice-api/auth/login', { email, password });
      login(res.data.user, res.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Invoice Portal</h2>
        <p style={styles.subtitle}>Massive Designs</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#0f0f0f'
  },
  card: {
    background: '#1a1a1a', padding: '2.5rem', borderRadius: '12px',
    width: '100%', maxWidth: '400px', border: '1px solid #2a2a2a'
  },
  title: { color: '#fff', fontSize: '24px', fontWeight: '700', marginBottom: '4px', textAlign: 'center' },
  subtitle: { color: '#888', fontSize: '14px', textAlign: 'center', marginBottom: '2rem' },
  error: { background: '#2a1a1a', color: '#ff6b6b', padding: '10px', borderRadius: '8px', marginBottom: '1rem', fontSize: '14px' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '6px' },
  input: {
    width: '100%', padding: '10px 12px', background: '#111', border: '1px solid #333',
    borderRadius: '8px', color: '#fff', fontSize: '14px', boxSizing: 'border-box'
  },
  btn: {
    width: '100%', padding: '12px', background: '#fff', color: '#000',
    border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600',
    cursor: 'pointer', marginTop: '0.5rem'
  }
};

export default Login;